module.exports = __webpack_public_path__ + "media/sora_multi_modal_input.ce05a171.mp4";